// import React, { useState, useEffect } from 'react';
// import { Helmet } from 'react-helmet';
// import { Link } from 'react-router-dom';
// import FAQSchema from '../../FAQSchema';
// import AdBanner from '../AdPage/AdBanner';


// const APYCalculator = () => {
//   const [joiningAge, setJoiningAge] = useState(25);
//   const [desiredPension, setDesiredPension] = useState(1000);
//   const [monthlyInvestment, setMonthlyInvestment] = useState(0);
//   const [investmentDuration, setInvestmentDuration] = useState(0);
//   const [totalAmount, setTotalAmount] = useState(0);

//   // useEffect(() => {
//   //   calculateAPY(joiningAge, desiredPension);
//   // }, [joiningAge, desiredPension]);

//   // const calculateAPY = (joiningAge, desiredPension) => {
//   //   // Implement the logic to calculate monthly investment, duration, and total amount
//   //   const duration = 60 - joiningAge; // Assuming retirement age is 60
//   //   const investment = (desiredPension / duration) * 2; // Simplified example calculation
//   //   const total = investment * duration * 12; // Total amount paid till retirement

//   //   setInvestmentDuration(duration);
//   //   setMonthlyInvestment(investment.toFixed(2));
//   //   setTotalAmount(total.toFixed(2));
//   // };

//   // const handleAgeChange = (e) => {
//   //   const value = e.target.value === '' ? 0 : parseInt(e.target.value);
//   //   setJoiningAge(value);
//   // };

//   // const handlePensionChange = (e) => {
//   //   const value = e.target.value === '' ? 0 : parseInt(e.target.value);
//   //   setDesiredPension(value);
//   // };
//  // Amount constants table from the image code
//  const amountConstants = {
//   "18": { 1000: 42, 2000: 84, 3000: 126, 4000: 168, 5000: 210 },
//   "19": { 1000: 46, 2000: 92, 3000: 138, 4000: 183, 5000: 228 },
//   "20": { 1000: 50, 2000: 100, 3000: 150, 4000: 198, 5000: 248 },
//   "21": { 1000: 54, 2000: 108, 3000: 162, 4000: 215, 5000: 269 },
//   "22": { 1000: 59, 2000: 117, 3000: 177, 4000: 234, 5000: 292 },
//   "23": { 1000: 64, 2000: 127, 3000: 192, 4000: 254, 5000: 318 },
//   "24": { 1000: 70, 2000: 139, 3000: 208, 4000: 277, 5000: 346 },
//   "25": { 1000: 76, 2000: 151, 3000: 226, 4000: 301, 5000: 376 },
//   "26": { 1000: 82, 2000: 164, 3000: 246, 4000: 327, 5000: 409 },
//   "27": { 1000: 90, 2000: 178, 3000: 268, 4000: 356, 5000: 446 },
//   "28": { 1000: 97, 2000: 194, 3000: 292, 4000: 388, 5000: 485 },
//   "29": { 1000: 106, 2000: 212, 3000: 318, 4000: 423, 5000: 529 },
//   "30": { 1000: 116, 2000: 231, 3000: 347, 4000: 462, 5000: 577 },
//   "31": { 1000: 126, 2000: 252, 3000: 379, 4000: 504, 5000: 630 },
//   "32": { 1000: 138, 2000: 276, 3000: 414, 4000: 551, 5000: 689 },
//   "33": { 1000: 151, 2000: 302, 3000: 453, 4000: 602, 5000: 752 },
//   "34": { 1000: 165, 2000: 330, 3000: 495, 4000: 659, 5000: 824 },
//   "35": { 1000: 181, 2000: 362, 3000: 543, 4000: 722, 5000: 902 },
//   "36": { 1000: 198, 2000: 396, 3000: 594, 4000: 792, 5000: 990 },
//   "37": { 1000: 218, 2000: 436, 3000: 654, 4000: 870, 5000: 1087 },
//   "38": { 1000: 240, 2000: 480, 3000: 720, 4000: 957, 5000: 1196 },
//   "39": { 1000: 264, 2000: 528, 3000: 792, 4000: 1054, 5000: 1318 },
// };

// useEffect(() => {
//   calculateAPY();
// }, [joiningAge, desiredPension]);

// const calculateAPY = () => {
//   // Calculate duration (retirement age - joining age)
//   const duration = 60 - joiningAge;
  
//   // Get monthly investment from the constants table
//   const investment = amountConstants[joiningAge.toString()] && 
//                      amountConstants[joiningAge.toString()][desiredPension] ? 
//                      amountConstants[joiningAge.toString()][desiredPension] : 0;
  
//   // Calculate total amount
//   const total = investment * 12 * duration;

//   setInvestmentDuration(duration);
//   setMonthlyInvestment(investment);
//   setTotalAmount(total);
// };

// const handleAgeChange = (e) => {
//   const value = e.target.value === '' ? 0 : parseInt(e.target.value);
//   setJoiningAge(value);
// };

// const handlePensionChange = (e) => {
//   const value = e.target.value === '' ? 0 : parseInt(e.target.value);
//   setDesiredPension(value);
// };
//   function Icon({ id, open }) {
//     return (
//         <svg
//             xmlns="http://www.w3.org/2000/svg"
//             fill="none"
//             viewBox="0 0 24 24"
//             strokeWidth={2}
//             stroke="currentColor"
//             className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
//         >
//             <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
//         </svg>
//     );
//   }
  
  
//     const [activeIndex, setActiveIndex] = useState(0);
  
     
//     const faqs = [
//       {
//         question: 'Who can use the APY calculator?',
//         answer: 'Anyone aged between 18 and 40 years can use the calculator to plan APY contributions based on their desired pension amount.',
//       },
//       {
//         question: 'Is the APY calculator free to use?',
//         answer: 'Yes, TheFinMaster\'s APY calculator is completely free and accessible online anytime.',
//       },
//       {
//         question: 'How accurate is the APY calculator?',
//         answer: 'The calculator uses government-approved pension slabs, ensuring reliable and precise contribution estimates.',
//       },
//       {
//         question: 'Can I change my pension amount after enrolling?',
//         answer: 'Yes, you can change your pension amount once a year by notifying your bank.',
//       },
//       {
//         question: 'Is APY only for unorganized sector workers?',
//         answer: 'While it targets workers in the unorganized sector, any Indian citizen aged 18–40 with a savings account can enroll.',
//       },
//       {
//         question: 'What happens if I miss a monthly payment?',
//         answer: 'Penalties are levied for missed payments. Continuous defaults can result in account suspension or closure.',
//       },
//       {
//         question: 'Is there a tax benefit under APY?',
//         answer: 'Yes, contributions qualify for deductions under Section 80CCD(1) of the Income Tax Act.',
//       },
//       {
//         question: 'How is the APY pension amount funded?',
//         answer: 'The pension is funded through your monthly contributions, accrued interest, and government co-contributions for eligible subscribers.',
//       },
//       {
//         question: 'Is the pension amount fixed?',
//         answer: 'Yes, the pension is fixed based on the amount and age selected during enrollment.',
//       },
//       {
//         question: 'Can NRIs join APY?',
//         answer: 'No, only resident Indian citizens are eligible for the Atal Pension Yojana.',
//       },
//       {
//         question: 'Can I open both APY and NPS accounts?',
//         answer: 'Yes, you can invest in both APY and NPS to diversify your retirement planning.',
//       },
//       {
//         question: 'How secure is my investment in APY?',
//         answer: 'APY is regulated by PFRDA and backed by the Government of India, making it a secure retirement option.',
//       },
//       {
//         question: 'How can I enroll in APY?',
//         answer: 'You can enroll through your bank branch or via your bank’s internet or mobile banking services.',
//       },
//       {
//         question: 'Will I get a lump sum at maturity?',
//         answer: 'No, APY offers a fixed monthly pension after 60. There is no lump sum payout at maturity.',
//       },
//       {
//         question: 'What happens if the subscriber dies before age 60?',
//         answer: 'The spouse can either continue the contributions or withdraw the accumulated corpus as per scheme rules.',
//       },
//     ];
//     const toggleAccordion = (index) => {
//       if (activeIndex === index) {
//           // If the clicked question is already expanded, collapse it
//           setActiveIndex(null);
//       } else {
//           // If the clicked question is not expanded, expand it
//           setActiveIndex(index);
//       };
//     }
//   return (
//     <>
//      <Helmet>
//          <title>APY Calculator – Atal Pension Yojana Benefits Estimator</title>
//         <meta  name='description' content='Estimate pension amount and contribution under the Atal Pension Yojana with our easy-to-use APY calculator.'/>
//         <meta name='keywords' content='apy pension calculator, apy contribution chart, atal pension yojana calculator in post office, atal pension yojana calculator sbi, atal pension yojana maturity amount' />
//         <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/apy-calculator" />
//         <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
//         <meta name="robots" content="max-video-preview:-1" />
//       </Helmet>
//       <FAQSchema faqs={faqs} />
//       {/* <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
//       <ol className="list-none p-0 inline-flex">
//         <li className="flex items-center">
//           <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
//           <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
//             <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
//           </svg>
//         </li>
//         <li className="flex items-center">
//           <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
//           <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
//             <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
//           </svg>
//         </li>
//           <li className="flex items-center">
//           <span className="text-gray-500 ">APY Calculator</span>
//         </li> 
      
//       </ol>
//     </nav> */}
//         <div className="w-full flex justify-center items-center px-4 mt-20">
//   <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
//   <AdBanner displayOrder="1" />
//   </div>
// </div>
//       <div className='py-4'>

//         <div className="container mx-auto p-4 max-w-7xl">
//           <div className="flex flex-wrap -mx-4">
//             <div className="w-full lg:w-2/3 px-4">

//               <div className="bg-white shadow-md rounded-md p-6 ">
//                 <h2 className="text-2xl font-bold mb-4">APY Calculator</h2>
//                 <div className="mb-4">
//                   <label className="block text-gray-700 font-semibold">Your joining age</label>
//                   <div className="flex items-center">
//                     <input
//                       type="number"
//                       min="18"
//                       max="40"
//                       value={joiningAge}
//                       onChange={handleAgeChange}
//                       className="w-1/2 p-2 border rounded mr-2"
//                     />
//                     <span className="text-gray-700">{joiningAge} yrs</span>
//                   </div>
//                   <input
//                     type="range"
//                     min="18"
//                     max="40"
//                     value={joiningAge}
//                     onChange={(e) => setJoiningAge(parseInt(e.target.value))}
//                     className="w-full mt-2"
//                   />
//                 </div>
//                 <div className="mb-4">
//                   <label className="block text-gray-700 font-semibold">Desired monthly pension</label>
//                   <div className="flex items-center">
//                     <input
//                       type="number"
//                       min="1000"
//                       max="5000"
//                       step="500"
//                       value={desiredPension}
//                       onChange={handlePensionChange}
//                       className="w-1/2 p-2 border rounded mr-2"
//                     />
//                     <span className="text-gray-700">₹ {desiredPension.toLocaleString()}</span>
//                   </div>
//                   <input
//                     type="range"
//                     min="1000"
//                     max="5000"
//                     step="500"
//                     value={desiredPension}
//                     onChange={(e) => setDesiredPension(parseInt(e.target.value))}
//                     className="w-full mt-2"
//                   />
//                 </div>
//                 <div className="mt-4">
//                   <div className="flex justify-between mb-2">
//                     <span className="font-semibold">Monthly investment:</span>
//                     <span>₹ {monthlyInvestment.toLocaleString()}</span>
//                   </div>
//                   <div className="flex justify-between mb-2">
//                     <span className="font-semibold">Investment duration:</span>
//                     <span>{investmentDuration} yrs</span>
//                   </div>
//                   <div className="flex justify-between mb-2">
//                     <span className="font-semibold">Total amount:</span>
//                     <span>₹ {totalAmount.toLocaleString()}</span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="w-full lg:w-1/3 px-4 mt-8 lg:mt-0 text-center">
//               <div className="bg-white shadow-md rounded-md p-6">
//                 <h2 className="text-xl font-bold mb-4">Invest the way you want</h2>
//                 <img src='https://www.shutterstock.com/image-illustration/credit-cards-online-shopping-banner-260nw-355524626.jpg' alt='noimage' />
//                 <p>Join millions of Indians who trust and love TheFinMaster</p>
//                 <button className="bg-green-500 text-white px-4 py-2 rounded mt-4">Explore Products</button>
//               </div>
//             </div>
//           </div>
//         </div>

import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import FAQSchema from '../../FAQSchema';
import AdBanner from '../AdPage/AdBanner';


const APYCalculator = () => {
  const [joiningAge, setJoiningAge] = useState(25);
  const [desiredPension, setDesiredPension] = useState(1000);
  const [monthlyInvestment, setMonthlyInvestment] = useState(0);
  const [investmentDuration, setInvestmentDuration] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);

 // Amount constants table from the image code
 const amountConstants = {
  "18": { 1000: 42, 2000: 84, 3000: 126, 4000: 168, 5000: 210 },
  "19": { 1000: 46, 2000: 92, 3000: 138, 4000: 183, 5000: 228 },
  "20": { 1000: 50, 2000: 100, 3000: 150, 4000: 198, 5000: 248 },
  "21": { 1000: 54, 2000: 108, 3000: 162, 4000: 215, 5000: 269 },
  "22": { 1000: 59, 2000: 117, 3000: 177, 4000: 234, 5000: 292 },
  "23": { 1000: 64, 2000: 127, 3000: 192, 4000: 254, 5000: 318 },
  "24": { 1000: 70, 2000: 139, 3000: 208, 4000: 277, 5000: 346 },
  "25": { 1000: 76, 2000: 151, 3000: 226, 4000: 301, 5000: 376 },
  "26": { 1000: 82, 2000: 164, 3000: 246, 4000: 327, 5000: 409 },
  "27": { 1000: 90, 2000: 178, 3000: 268, 4000: 356, 5000: 446 },
  "28": { 1000: 97, 2000: 194, 3000: 292, 4000: 388, 5000: 485 },
  "29": { 1000: 106, 2000: 212, 3000: 318, 4000: 423, 5000: 529 },
  "30": { 1000: 116, 2000: 231, 3000: 347, 4000: 462, 5000: 577 },
  "31": { 1000: 126, 2000: 252, 3000: 379, 4000: 504, 5000: 630 },
  "32": { 1000: 138, 2000: 276, 3000: 414, 4000: 551, 5000: 689 },
  "33": { 1000: 151, 2000: 302, 3000: 453, 4000: 602, 5000: 752 },
  "34": { 1000: 165, 2000: 330, 3000: 495, 4000: 659, 5000: 824 },
  "35": { 1000: 181, 2000: 362, 3000: 543, 4000: 722, 5000: 902 },
  "36": { 1000: 198, 2000: 396, 3000: 594, 4000: 792, 5000: 990 },
  "37": { 1000: 218, 2000: 436, 3000: 654, 4000: 870, 5000: 1087 },
  "38": { 1000: 240, 2000: 480, 3000: 720, 4000: 957, 5000: 1196 },
  "39": { 1000: 264, 2000: 528, 3000: 792, 4000: 1054, 5000: 1318 },
};

const calculateAPY = () => {
  // Calculate duration (retirement age - joining age)
  const duration = 60 - joiningAge;
  
  // Get monthly investment from the constants table
  const investment = amountConstants[joiningAge.toString()] && 
                     amountConstants[joiningAge.toString()][desiredPension] ? 
                     amountConstants[joiningAge.toString()][desiredPension] : 0;
  
  // Calculate total amount
  const total = investment * 12 * duration;

  setInvestmentDuration(duration);
  setMonthlyInvestment(investment);
  setTotalAmount(total);
};

const handleAgeChange = (e) => {
  const value = e.target.value === '' ? 0 : parseInt(e.target.value);
  setJoiningAge(value);
};

const handlePensionChange = (e) => {
  const value = e.target.value === '' ? 0 : parseInt(e.target.value);
  setDesiredPension(value);
};
  function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  
    const [activeIndex, setActiveIndex] = useState(0);
  
     
    const faqs = [
      {
        question: 'Who can use the APY calculator?',
        answer: 'Anyone aged between 18 and 40 years can use the calculator to plan APY contributions based on their desired pension amount.',
      },
      {
        question: 'Is the APY calculator free to use?',
        answer: 'Yes, TheFinMaster\'s APY calculator is completely free and accessible online anytime.',
      },
      {
        question: 'How accurate is the APY calculator?',
        answer: 'The calculator uses government-approved pension slabs, ensuring reliable and precise contribution estimates.',
      },
      {
        question: 'Can I change my pension amount after enrolling?',
        answer: 'Yes, you can change your pension amount once a year by notifying your bank.',
      },
      {
        question: 'Is APY only for unorganized sector workers?',
        answer: 'While it targets workers in the unorganized sector, any Indian citizen aged 18–40 with a savings account can enroll.',
      },
      {
        question: 'What happens if I miss a monthly payment?',
        answer: 'Penalties are levied for missed payments. Continuous defaults can result in account suspension or closure.',
      },
      {
        question: 'Is there a tax benefit under APY?',
        answer: 'Yes, contributions qualify for deductions under Section 80CCD(1) of the Income Tax Act.',
      },
      {
        question: 'How is the APY pension amount funded?',
        answer: 'The pension is funded through your monthly contributions, accrued interest, and government co-contributions for eligible subscribers.',
      },
      {
        question: 'Is the pension amount fixed?',
        answer: 'Yes, the pension is fixed based on the amount and age selected during enrollment.',
      },
      {
        question: 'Can NRIs join APY?',
        answer: 'No, only resident Indian citizens are eligible for the Atal Pension Yojana.',
      },
      {
        question: 'Can I open both APY and NPS accounts?',
        answer: 'Yes, you can invest in both APY and NPS to diversify your retirement planning.',
      },
      {
        question: 'How secure is my investment in APY?',
        answer: 'APY is regulated by PFRDA and backed by the Government of India, making it a secure retirement option.',
      },
      {
        question: 'How can I enroll in APY?',
        answer: 'You can enroll through your bank branch or via your banks internet or mobile banking services.',
      },
      {
        question: 'Will I get a lump sum at maturity?',
        answer: 'No, APY offers a fixed monthly pension after 60. There is no lump sum payout at maturity.',
      },
      {
        question: 'What happens if the subscriber dies before age 60?',
        answer: 'The spouse can either continue the contributions or withdraw the accumulated corpus as per scheme rules.',
      },
    ];
    const toggleAccordion = (index) => {
      if (activeIndex === index) {
          // If the clicked question is already expanded, collapse it
          setActiveIndex(null);
      } else {
          // If the clicked question is not expanded, expand it
          setActiveIndex(index);
      };
    }
  return (
    <>
     <Helmet>
         <title>APY Calculator – Atal Pension Yojana Benefits Estimator</title>
        <meta  name='description' content='Estimate pension amount and contribution under the Atal Pension Yojana with our easy-to-use APY calculator.'/>
        <meta name='keywords' content='apy pension calculator, apy contribution chart, atal pension yojana calculator in post office, atal pension yojana calculator sbi, atal pension yojana maturity amount' />
        <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/apy-calculator" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      {/* <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
      <ol className="list-none p-0 inline-flex">
        <li className="flex items-center">
          <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
        <li className="flex items-center">
          <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
          <li className="flex items-center">
          <span className="text-gray-500 ">APY Calculator</span>
        </li> 
      
      </ol>
    </nav> */}
        <div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
      <div className='py-4'>

        <div className="container mx-auto p-4 max-w-7xl">
          <div className="flex flex-wrap -mx-4">
            <div className="w-full lg:w-2/3 px-4">

              <div className="bg-white shadow-md rounded-md p-6 ">
                <h1 className="text-2xl font-bold mb-4">APY Calculator</h1>
                <div className="mb-4">
                  <label className="block text-gray-700 font-semibold">Your joining age</label>
                  <div className="flex items-center">
                    <input
                      type="number"
                      min="18"
                      max="40"
                      value={joiningAge}
                      onChange={handleAgeChange}
                      className="w-1/2 p-2 border rounded mr-2"
                    />
                    <span className="text-gray-700">{joiningAge} yrs</span>
                  </div>
                  <input
                    type="range"
                    min="18"
                    max="40"
                    value={joiningAge}
                    onChange={(e) => setJoiningAge(parseInt(e.target.value))}
                    className="w-full mt-2"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-gray-700 font-semibold">Desired monthly pension</label>
                  <div className="flex items-center">
                    <input
                      type="number"
                      min="1000"
                      max="5000"
                      step="500"
                      value={desiredPension}
                      onChange={handlePensionChange}
                      className="w-1/2 p-2 border rounded mr-2"
                    />
                    <span className="text-gray-700">₹ {desiredPension.toLocaleString()}</span>
                  </div>
                  <input
                    type="range"
                    min="1000"
                    max="5000"
                    step="500"
                    value={desiredPension}
                    onChange={(e) => setDesiredPension(parseInt(e.target.value))}
                    className="w-full mt-2"
                  />
                </div>
                
                {/* Calculate Button */}
                <div className="mb-6 ">
                  <button
                    onClick={calculateAPY}
                    className="bg-blue-500 text-white px-4 py-2 rounded"
                  >
                    Calculate
                  </button>
                </div>

                <div className="mt-4">
                  <div className="flex justify-between mb-2">
                    <span className="font-semibold">Monthly investment:</span>
                    <span>₹ {monthlyInvestment.toLocaleString()}</span>
                  </div>
                  <div className="flex justify-between mb-2">
                    <span className="font-semibold">Investment duration:</span>
                    <span>{investmentDuration} yrs</span>
                  </div>
                  <div className="flex justify-between mb-2">
                    <span className="font-semibold">Total amount:</span>
                    <span>₹ {totalAmount.toLocaleString()}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-1/3 px-4 mt-8 lg:mt-0 text-center">
              <div className="bg-white shadow-md rounded-md p-6">
                <h2 className="text-xl font-bold mb-4">Invest the way you want</h2>
                <img src='https://www.shutterstock.com/image-illustration/credit-cards-online-shopping-banner-260nw-355524626.jpg' alt='noimage' />
                <p>Join millions of Indians who trust and love TheFinMaster</p>
                <button className="bg-green-500 text-white px-4 py-2 rounded mt-4">Explore Products</button>
              </div>
            </div>
          </div>
        </div>


        <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
        <div className="w-full md:w-2/3 p-4 mx-auto">
        <div className="container mx-auto py-4">
          <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            What is Atal Pension Yojana (APY)?
          </h2>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            The Atal Pension Yojana (APY) is a government-sponsored pension scheme aimed primarily at individuals working in the unorganized sector who often lack access to traditional pension benefits. Introduced in the 2015-16 Union Budget and managed by the Pension Fund Regulatory and Development Authority (PFRDA), APY is designed to provide a steady and secure income stream after retirement. However, the scheme is also open to private-sector employees and anyone within the age group of 18 to 40 years, provided they contribute regularly till they turn 60.
          </p>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            Under APY, subscribers are guaranteed a fixed monthly pension amount ranging from Rs. 1,000 to Rs. 5,000 after they reach the age of 60. The specific pension amount depends on the subscriber’s age at the time of joining and their monthly contribution. Contributions are automatically debited from the bank account, ensuring hassle-free investments.
          </p>
</div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is an APY Calculator?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              An APY calculator is an online tool that helps you estimate your pension benefits and understand how much you need to invest monthly to receive your desired pension amount post-retirement. It simplifies the complex calculations by taking your age and desired pension amount as inputs and returning your estimated monthly contribution, total investment, and projected benefits.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The calculator uses predefined formulas and pension charts prescribed by the government to generate accurate results. This tool is especially useful for financial planning, allowing you to visualize long-term returns and make informed decisions.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Does the Atal Pension Yojana Work?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The APY is structured around a voluntary subscription model where an individual chooses a fixed monthly pension amount they want to receive upon retirement. Here's a breakdown of how the scheme works:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Age of Enrollment:</strong> You must be between 18 and 40 years to enroll. The earlier you join, the smaller your monthly contribution.</li>
              <li><strong>Contribution Period:</strong> You contribute regularly until you turn 60.</li>
              <li><strong>Monthly Contributions:</strong> Based on your selected pension and age at joining, a specific monthly amount is auto-debited from your savings bank account.</li>
              <li><strong>Guaranteed Pension:</strong> After turning 60, you begin receiving the monthly pension you opted for.</li>
              <li><strong>Spouse and Nominee Benefit:</strong> If the subscriber dies, the spouse continues to receive the pension. In case of both spouse and subscriber's demise, the accumulated corpus is given to the nominee.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Does the Atal Pension Yojana Return Calculator Work?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This APY calculator calculates APY based on two values: interest and compound frequency. You can compare a number of offers with different compounding periods by using the choices in the second box.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              For instance, consider the following offers:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>An annual interest rate of 1% is compounded, thus APY = 1%.</li>
              <li>Interest rate of 0.75% compounded quarterly, APY = 0.702%</li>
              <li>APY = 0.501 percent, interest rate of 0.5% compounded daily</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              All you have to know now is that the greater the APY value, the better the offer. Calculating APY reveals that the first of the illustrative offers pays the highest.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Here is the formula followed to calculate the Atal Pension Yojana:
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              APY = (1 + r/n)<sup>n</sup> – 1
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              where:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>r – stands for the interest rate.</li>
              <li>n – stands for the number of times the interest is compounded per year.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Benefits of Using TheFinMaster’s APY Calculator
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The APY calculator by TheFinMaster comes with several user-centric advantages that make it a vital tool for retirement planning:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Personalized Pension Planning:</strong> Get a detailed outlook based on your age and pension preference.</li>
              <li><strong>Instant and Accurate Results:</strong> No manual calculation required; receive instant estimates.</li>
              <li><strong>User-Friendly Interface:</strong> Easy navigation even for users new to financial planning.</li>
              <li><strong>Avoids Errors:</strong> Reduces the risk of manual calculation mistakes.</li>
              <li><strong>Financial Clarity:</strong> Understand your investment tenure, contribution amount, and retirement benefits in one glance.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Key Components Considered by the APY Calculator
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The calculator considers the following key data points:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Age of the subscriber at enrollment</li>
              <li>Desired pension amount</li>
              <li>Government-fixed contribution chart</li>
              <li>Automatic interest adjustments if applicable</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              It uses government-approved actuarial data to calculate the monthly contribution needed and the total amount invested by the time of maturity (age 60).
            </p>
          </div>
          <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="2" />
        </div>
         
        </div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How to Use TheFinMaster’s APY Calculator
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Using TheFinMaster’s APY calculator is a straightforward process:
            </p>
            <ul className="list-decimal pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Enter Your Current Age:</strong> This helps determine your contribution period.</li>
              <li><strong>Choose Your Monthly Pension Target:</strong> Options range from Rs. 1,000 to Rs. 5,000.</li>
              <li><strong>Get Results Instantly:</strong> The calculator will show you the exact monthly contribution, total investment, and tenure.</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This eliminates all guesswork and gives you the exact numbers needed to meet your pension goals.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Example Calculation Using TheFinMaster's APY Calculator
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Suppose a 25-year-old wants to receive a monthly pension of Rs. 4,000 at age 60. Using the calculator:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Monthly Contribution:</strong> Rs. 293 approx.</li>
              <li><strong>Total Years of Contribution:</strong> 35 years</li>
              <li><strong>Total Investment:</strong> Rs. 1,23,060 (approx.)</li>
              <li><strong>Pension at Age 60:</strong> Rs. 4,000 per month guaranteed</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This showcases the power of long-term investing and how even a small monthly commitment can lead to a stable retirement.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why Use an APY Calculator for Retirement Planning?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Planning your retirement without clarity can be financially risky. Here’s why the APY calculator is crucial:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>It provides complete transparency about your pension benefits.</li>
              <li>You get to understand how much you need to invest monthly to secure your retirement.</li>
              <li>It helps align your current financial capacity with your future needs.</li>
              <li>It enables better decision-making on whether to invest in APY or explore other pension plans.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Understanding APY vs Other Retirement Plans
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              While NPS and EPF are commonly chosen by salaried individuals, APY is ideal for low-income earners and those in the informal sector. Here’s how APY stands out:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Low Monthly Contributions</li>
              <li>Guaranteed Returns</li>
              <li>Government-Backed Security</li>
              <li>Spouse and Nominee Coverage</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              For individuals looking for minimal-risk, assured pension income, APY provides a simple, secure solution.
            </p>
          </div>
        </div>

          <div className="w-full md:w-1/3 p-4">
            <div className="bg-white shadow-md rounded-lg overflow-hidden">
              <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
                <h2 className="text-lg font-semibold ">Popular Categories</h2>
              </div>
              <div className="p-2 ">
              <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>
                       {/* Ad Banner */}
  <div className="mt-4">
    <div className="bg-white shadow-md rounded-lg overflow-hidden">
      <div className="p-3 w-full h-auto rounded-md object-cover">
        <AdBanner displayOrder="3" />
      </div>
    </div>
  </div>
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                            <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                {/* <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link> */}
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
                  {/* {moreCategories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                </ul>
              </div>
            </div>

          </div>

        </div>
      </div>
      <div className="max-w-4xl mx-auto lg:px-6 md:px-6 px-2 py-6">
                <h2 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h2>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
    </>
  );
};

export default APYCalculator;
